import { render, staticRenderFns } from "./QuotesImage.vue?vue&type=template&id=5dab8fe8&scoped=true&"
import script from "./QuotesImage.vue?vue&type=script&lang=ts&"
export * from "./QuotesImage.vue?vue&type=script&lang=ts&"
import style0 from "./QuotesImage.vue?vue&type=style&index=0&id=5dab8fe8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dab8fe8",
  null
  
)

export default component.exports